<template>
    <div>
        <modal
            :is-open="isOpen"
            :is-loading="loading"
            :disabled="loading"
            btn-save-title="Открыть доступ"
            :btn-save-classes="['cabinet-btn--green']"
            title="Открыть доступ?"
            @onCloseModal="closeModal"
            @onSaveModal="saveModal"
        >
            Ритейлер
            <span class="text-bold">{{
                access.retailer ? access.retailer.company_name : ''
            }}</span>
            получит доступ к изделиям с ограниченным доступом.
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/Elements/Modal'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'ApproveModal',
    components: { Modal },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        access: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false
        }
    },
    computed: {
        ...mapState('supplierAccessControl', ['errors'])
    },
    methods: {
        ...mapActions('supplierAccessControl', ['approveAccess']),
        closeModal() {
            this.$emit('closeModal')
        },
        async saveModal() {
            if (this.loading) return

            this.loading = true

            try {
                await this.approveAccess(this.access.BrandItemsAccessID)

                this.$notify({
                    title: 'Доступ открыт',
                    type: 'success'
                })

                this.$emit('approveModalSaved')
            } catch (e) {
                console.log(e)
                this.$notify({
                    title: 'Ошибка',
                    type: 'error'
                })
            }

            this.loading = false
        }
    }
}
</script>
